import adminLayout from '@/admin/layouts/LayoutOne.vue';

export default [
    {
        path: '/admin/payroll',
        name: 'PayrollModule',
        component: () => import('@/admin/modules/payroll/PayrollManagement.vue'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/advance-salary',
        name: 'AdvanceSalaryModule',
        component: () => import('@/admin/modules/payroll/advance/AdvanceSalaryModule.vue'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/advance-salary-decision',
        name: 'AdvanceSalaryDecision',
        component: () => import('@/admin/modules/payroll/advance/AdvanceSalaryDecision.vue'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/salary-deduction-policy',
        name: 'SalaryDeductionPolicyModule',
        component: () => import('@/admin/modules/payroll/deduction/SalaryDeductionPolicyModule.vue'),
        meta: { layout: adminLayout, requiresAuth:true }
    }
];